/* Pénombre, couche « maison établie » (audit 22/09/2026). */
(function(){
  'use strict';
  var mqMobile = window.matchMedia('(max-width: 749px)');

  function ls(get, key, val){
    try{ return get ? localStorage.getItem(key) : localStorage.setItem(key, val); }catch(e){ return null; }
  }
  function ss(get, key, val){
    try{ return get ? sessionStorage.getItem(key) : sessionStorage.setItem(key, val); }catch(e){ return null; }
  }

  /* 1. Bilan teaser popup : après engagement réel, une fois par session,
        jamais au premier écran, pas de réapparition pendant 30 jours.
        Redirige vers /pages/bilan-penombre (pas de formulaire inline). */
  function initOffer(){
    var el = document.querySelector('[data-pm-offer]');
    if(!el) return;
    var body = document.body;
    if(/template-(cart|password|customers)/.test(body.className)) return;
    if(/template-page-bilan-penombre/.test(body.className)) return;
    var last = parseInt(ls(true, 'pm_offer_dismissed') || '0', 10);
    if(ls(true, 'pm_offer_subscribed') || ss(true, 'pm_offer_seen')) return;
    if(last && Date.now() - last < 30 * 864e5) return;

    var views = parseInt(ss(true, 'pm_pageviews') || '0', 10) + 1;
    ss(false, 'pm_pageviews', String(views));
    var start = Date.now(), shown = false;

    function engaged(){
      var t = (Date.now() - start) / 1000;
      var deep = window.scrollY > window.innerHeight * 1.5;
      return (deep && t > 25) || (views >= 2 && t > 20 && window.scrollY > window.innerHeight);
    }
    function show(){
      if(shown || document.querySelector('.cart-drawer.is-open, .contact-widget.is-open')) return;
      shown = true;
      ss(false, 'pm_offer_seen', '1');
      el.classList.add('is-visible');
      el.hidden = false;
      body.classList.add('pm-float-busy');
      cleanup();
      if(window.lumaPushEvent) window.lumaPushEvent('bilan_popup_shown', {});
    }
    function check(){ if(engaged()) show(); }
    var timer = setInterval(check, 4000);
    window.addEventListener('scroll', check, { passive:true });
    function cleanup(){ clearInterval(timer); window.removeEventListener('scroll', check); }

    function dismiss(){
      el.classList.remove('is-visible');
      body.classList.remove('pm-float-busy');
      ls(false, 'pm_offer_dismissed', String(Date.now()));
    }
    el.querySelectorAll('[data-pm-offer-close]').forEach(function(b){ b.addEventListener('click', dismiss); });
    el.querySelector('.pm-offer__backdrop').addEventListener('click', dismiss);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && el.classList.contains('is-visible')) dismiss(); });

    var cta = el.querySelector('[data-bilan-cta]');
    if(cta){
      cta.addEventListener('click', function(){
        if(window.lumaPushEvent) window.lumaPushEvent('bilan_cta_click', {context:'popup'});
        dismiss();
      });
    }
  }

  /* 2. CTA sticky : visible seulement une fois le bouton initial dépassé. */
  function initSticky(){
    var bar = document.querySelector('[data-pm-sticky]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if(!bar || !anchor) return;
    function update(){
      var passed = anchor.getBoundingClientRect().bottom < 0;
      var footer = document.querySelector('footer, .site-footer');
      var nearEnd = footer && footer.getBoundingClientRect().top < window.innerHeight;
      var on = passed && !nearEnd && mqMobile.matches;
      bar.classList.toggle('is-visible', on);
      document.body.classList.toggle('pm-float-busy', on || !!document.querySelector('[data-pm-offer].is-visible'));
    }
    window.addEventListener('scroll', update, { passive:true });
    window.addEventListener('resize', update);
    update();
    var btn = bar.querySelector('[data-pm-sticky-add]');
    if(btn){
      btn.addEventListener('click', function(){
        var main = document.querySelector('[data-product-form] [data-add-to-cart]');
        if(main && !main.disabled){ main.click(); }
        else { anchor.scrollIntoView({ behavior:'smooth', block:'center' }); }
      });
    }
  }

  /* 3. Chapitres de la fiche produit repliés sur mobile (sauf le premier). */
  function initChapters(){
    var items = document.querySelectorAll('[data-pm-chapter]');
    if(!items.length) return;
    function apply(){
      items.forEach(function(d, i){
        if(mqMobile.matches){ if(i > 0) d.removeAttribute('open'); }
        else { d.setAttribute('open', ''); }
      });
    }
    apply();
    items.forEach(function(d){
      d.querySelector('summary').addEventListener('click', function(e){ if(!mqMobile.matches) e.preventDefault(); });
    });
    if(mqMobile.addEventListener) mqMobile.addEventListener('change', apply);
  }

  /* 4. Avis Judge.me : libellés en français, même lorsque l'app les injecte. */
  function frenchReviews(root){
    (root || document).querySelectorAll('.jdgm-prev-badge__text, .jdgm-rev-widg__summary-text, .jdgm-all-reviews-rating-text').forEach(function(n){
      var t = n.textContent;
      var f = t.replace(/(\\d+)\\s+reviews?/i, '$1 avis')
               .replace(/^\\s*No reviews\\s*$/i, 'Aucun avis')
               .replace(/Based on\\s+(\\d+)\\s+reviews?/i, 'Sur la base de $1 avis');
      if(f !== t) n.textContent = f;
    });
  }
  function initReviews(){
    frenchReviews();
    if(!('MutationObserver' in window)) return;
    var pending = false;
    new MutationObserver(function(){
      if(pending) return;
      pending = true;
      requestAnimationFrame(function(){ pending = false; frenchReviews(); });
    }).observe(document.body, { childList:true, subtree:true });
  }

  function init(){ initOffer(); initSticky(); initChapters(); initReviews(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
